import {create} from 'react-modal-promise';

import {UsersSidebar} from './index';

export const openUserSidebar = create(UsersSidebar);
